import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from '../container/login/Index';
import Spinner from '../components/utilities/Spinner';

const Login         = lazy(() => import('../container/login/SignIn'));
const ForgotPass    = lazy(() => import('../container/login/ForgotPassword'));


const FrontendRoutes = () => {
    return (
        <Suspense
            fallback={
                <div className="spin">
                <Spinner />
                </div>
            }
        >
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgotPassword" element={<ForgotPass />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Suspense>
    )
}

export default AuthLayout(FrontendRoutes);
